__turbopack_context__.v({
  "bottom-con": "noPolicyLink-module-scss-module__S98KSG__bottom-con",
  "button-con": "noPolicyLink-module-scss-module__S98KSG__button-con",
  "image-con": "noPolicyLink-module-scss-module__S98KSG__image-con",
  "main-con": "noPolicyLink-module-scss-module__S98KSG__main-con",
  "text-con": "noPolicyLink-module-scss-module__S98KSG__text-con",
  "top-con": "noPolicyLink-module-scss-module__S98KSG__top-con",
});
